<template>
  <div
    v-if="showInfoBox && userStore.user?.workEmailConfirmed === false"
    class="col-span-12 sticky top-[53px] z-50"
  >
    <div class="rounded-lg flex p-2 bg-alert-blue mb-5 flex-col items-center">
      <div class="flex flex-row flex-wrap justify-center">
        <div class="flex flex-row">
          <img src="~/assets/icons/alert-info.svg?url" class="w-4 m-1" />
          <p class="text-sm mx-1 py-2">
            {{ `${$t('EmailNotConfirmed')}. ${$t('activateemail')}` }}
          </p>
        </div>
        <CommonSendActivationEmailButton class="ml-3" />
      </div>
    </div>
  </div>
  <div
    class="container pt-8 pb-11 md:pb-20"
    :class="{ 'md:pt-16': !alert, 'md:pt-10': alert }"
  >
    <div class="grid-container gap-8 md:gap-10">
      <FormAlert
        v-if="alert"
        :message="$t(alert.message)"
        :type="alert.type"
        class="col-span-12"
      />
      <ul
        v-if="routes"
        class="col-span-12 font-sans text-sm md:text-base font-medium"
      >
        <li v-for="(item, index) in routes" :key="index" class="inline">
          <NuxtLink :to="{ name: item.route }">
            {{ $t(item.label) }}
          </NuxtLink>
          <span class="px-3">></span>
        </li>
        <li class="inline">{{ title }}</li>
      </ul>
      <div class="col-span-12 max-w-md">
        <h1 class="text-3xl md:text-5xl font-sans font-bold">
          {{ title }}
        </h1>
        <p v-if="subtitle" class="text-sm md:text-base pt-5">
          {{ subtitle }}
        </p>
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const userStore = useUserStore()

const props = defineProps<{
  title: string
  subtitle?: string
  routes?: { label: string; route: string }[]
  alert?: { message: string; type: AlertType }
  showInfoBox?: boolean
}>()

const alert = ref<{ message: string; type: AlertType } | undefined>(undefined)

watch(
  () => props.alert,
  () => {
    alert.value = props.alert
  }
)
</script>
